import Vue from "vue";
const setupGlobalMixins = (quasarScreen, lodashGet) => ({
  data: function() {
    return {
      deviceInfo
    };
  },
  computed: {
    mobile() {
      var _a, _b;
      return quasarScreen.sizes.md > ((_b = (_a = this.$q) == null ? void 0 : _a.screen) == null ? void 0 : _b.width);
    },
    tablet() {
      var _a;
      const screenWidth = (_a = this.$q) == null ? void 0 : _a.screen.width;
      return quasarScreen.sizes.md <= screenWidth && quasarScreen.sizes.lg > screenWidth;
    },
    desktop() {
      var _a;
      return quasarScreen.sizes.lg <= ((_a = this.$q) == null ? void 0 : _a.screen.width);
    }
  },
  methods: {
    get: lodashGet,
    isTheme(theme) {
      return this.$store.getters["theme/currentTheme"] === theme;
    },
    currentTheme() {
      var _a, _b;
      return (_b = (_a = this.$store) == null ? void 0 : _a.getters) == null ? void 0 : _b["theme/currentTheme"];
    }
  }
});
const deviceInfo = Vue.observable({
  touchInUse: "ontouchstart" in window || window.navigator.maxTouchPoints > 0,
  init() {
    let deactivatedMouse = false;
    let timeOut = null;
    document.body.addEventListener(
      "mouseover",
      () => this.touchInUse = deactivatedMouse
    );
    document.body.addEventListener("touchstart", () => {
      this.touchInUse = true;
      deactivatedMouse = true;
      if (timeOut) {
        clearTimeout(timeOut);
      }
      timeOut = setTimeout(() => {
        deactivatedMouse = false;
      }, 1e3);
    });
  }
});
export {
  deviceInfo,
  setupGlobalMixins
};
//# sourceMappingURL=globalMixins.es.js.map
